import { QueryParam } from "../../../types/api/generic.type";
import { GetPotentialMatrixCollaboratorsResponse } from "../../../types/api/potentialMatrix.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const PotentialMatrixCollaboratorsService = {
  async list(
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetPotentialMatrixCollaboratorsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response =
      await httpClient.get<GetPotentialMatrixCollaboratorsResponse>(
        `v1/potential-matrix/collaborators?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
        { signal },
      );
    return response;
  },
};

export default PotentialMatrixCollaboratorsService;
